export const autoRun = [
    {name: 'Practice Name', key: 'practice Name'},
    {name: 'Status', key: 'status'},
]

export const dateRange = [
    {key:'month_to_date', value:'Month to date'},
    {key:'year_to_date', value:'Year to date'},
]